// extracted by mini-css-extract-plugin
export default {"cls1":"PaperContainer-cls1_voF","cls2":"PaperContainer-cls2_FK1 PaperContainer-cls1_voF","size-medium":"PaperContainer-size-medium_wk8","size-large":"PaperContainer-size-large_OkV"};